// extracted by mini-css-extract-plugin
export var button = "Button-module--button--2t432";
export var buttonPlain = "Button-module--button--plain--2P4oZ";
export var buttonInline = "Button-module--button--inline--25nJO";
export var buttonDark = "Button-module--button--dark--3yT9N";
export var buttonHollow = "Button-module--button--hollow--1btoC";